import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PricingHeroComponent } from '../../Components/Pricing/pricing-hero/pricing-hero';
import { PricingPlansComponent } from '../../Components/Pricing/pricing-plans/pricing-plans';
import { PricingModulesComponent } from '../../Components/Pricing/pricing-modules/pricing-modules';
import { PricingFaqComponent } from '../../Components/Pricing/pricing-faq/pricing-faq';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-pricing-page',
  standalone: true,
  imports: [CommonModule, PricingHeroComponent, PricingPlansComponent, PricingModulesComponent, PricingFaqComponent],
  templateUrl: './pricing-page.html',
  styleUrls: ['./pricing-page.css'],
})
export class PricingPageComponent implements OnInit {
  isYearly = false;
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'Pricing Plans',
      description:
        'Simple, fair pricing for orderYaa ERP — from Rs 5,000/month. No usage-based fees, no hidden costs, unlimited users on every plan.',
      path: '/pricing',
    });
  }
}
